'use strict';
import React from 'react';
import FactoryCellInterface from './FactoryCellInterface';
import { RealtyType, Description, DescriptionAndType, Price, Area, Building, Land, Contacts, Date } from '../GridCells';

class FactoryGridCell extends FactoryCellInterface {
  makeRealtyType (key, data) {
    return <RealtyType key={key} item={data} user={this.user} domain={this.domain} />;
  }

  makeDescription (key, data, eventAddFavorites, eventRemoveFavorites, eventOpenCommentForm, eventOpenClaimForm, eventMapModal) {
    return <Description
      key={key}
      item={data}
      user={this.user}
      domain={this.domain}
      eventAddFavorites={eventAddFavorites}
      eventRemoveFavorites={eventRemoveFavorites}
      eventOpenCommentForm={eventOpenCommentForm}
      eventOpenClaimForm={eventOpenClaimForm}
      eventMapModal={eventMapModal}
    />;
  }

  makeDescriptionAndType (key, data, eventAddFavorites, eventRemoveFavorites, eventOpenCommentForm, eventOpenClaimForm, eventMapModal) {
    return <DescriptionAndType
      key={key}
      item={data}
      user={this.user}
      domain={this.domain}
      eventAddFavorites={eventAddFavorites}
      eventRemoveFavorites={eventRemoveFavorites}
      eventOpenCommentForm={eventOpenCommentForm}
      eventOpenClaimForm={eventOpenClaimForm}
      eventMapModal={eventMapModal}
    />;
  }

  makePrice (key, data) {
    return <Price key={key} item={data} />;
  }

  makePriceAndPay (key, data) {
    return this.makePrice(key, data);
  }

  makePriceAndPricePerMeter (key, data) {
    return this.makePrice(key, data);
  }

  makePricePerMeter (key, data) {
    return this.makePrice(key, data);
  }

  makeArea (key, data) {
    return <Area key={key} item={data} />;
  }

  makeBuilding (key, data) {
    return <Building key={key} item={data} />;
  }

  makeContacts (key, data, onUpdateFilter, eventShowContacts, rawData) {
    return <Contacts
      key={key}
      item={data}
      rawItem={rawData}
      user={this.user}
      onUpdateFilter={onUpdateFilter}
      eventShowContacts={eventShowContacts}
    />;
  }

  makeMoreProperty (key, data) {
    return this.makeBuilding(key, data);
  }

  makeDate (key, data) {
    return <Date key={key} item={data} />;
  }

  makeLand (key, data) {
    return <Land key={key} item={data} />;
  }
}

export default FactoryGridCell;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/Factory/FactoryGridCell.jsx